import { Storybook } from "@tento-ui/ui/storybook";
import { DshKvGrid } from "./kv-grid";

export class DshKvGridStoryBook extends Storybook.Default {
  title(): string {
    return "Turn dsh · kv-grid";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "The fixture's pairs",
        render: () =>
          DshKvGrid.makeWith({
            pairs: [
              ["session", "52738"],
              ["lanes", "ctl, news"],
              ["records", "34,430"],
              ["out of order", "4 (within lane)"],
              ["ms-precision stamps", "38"],
            ],
          }),
      },
      {
        title: "A session envelope",
        render: () =>
          DshKvGrid.makeWith({
            pairs: [
              ["session", "afb69f67-2c41-4e00-839b-da6dc00671ed"],
              ["lane", "opencode"],
              ["cwd", "/Users/james/workspace/tento"],
              ["model", "claude-opus-5"],
            ],
          }),
      },
      {
        title: "One pair",
        render: () => DshKvGrid.makeWith({ pairs: [["exit", "0"]] }),
      },
      {
        title: "A long value wraps in its own column, keys stay aligned",
        render: () =>
          DshKvGrid.makeWith({
            pairs: [
              [
                "path",
                "/Users/james/workspace/tento/tento-node-registry/tento-spool.node/html/routes/session-detail.ts",
              ],
              ["bytes", "10696"],
            ],
          }),
      },
      {
        title: "A long key does not squeeze the values",
        render: () =>
          DshKvGrid.makeWith({
            pairs: [
              ["parent_lineage_id", "legacy:16734:1785895224023052"],
              ["id", "16734"],
            ],
          }),
      },
      {
        title: "Empty — no card at all",
        render: () => DshKvGrid.makeWith({ pairs: [] }),
      },
    ];
  }
}
